
// src/web/components/user-extensions-panel.jsx

import React from 'react'
import connect from '../../connects/user-extensions-panel'
import {
  Card,
  CardText,
} from 'react-toolbox'
import {
  List,
  ListItem,
  ListSubHeader,
  ListDivider,
} from 'react-toolbox/lib/list'
import Loading from './loading.jsx'
import Avatar from 'react-toolbox/lib/avatar'
import theme from './themes/flat-card.css'
import UserNotificationList from './themes/user-notification-list.css'
import Switch from 'react-toolbox/lib/switch'
import _ from 'lodash'

function SettingMenu(props) {
  const {
    t,
    ui,
    selected,
    target,
    updateUI,
    isEnable,
    updateReviewSetting
  } = props

  const onChange = () => {
    updateReviewSetting()
  }

  return (
    <div className={theme.rightButton}>
      <Switch className={theme.switch}
        checked={isEnable}
        disabled
        onChange={() => updateReviewSetting()}/>
    </div>
  )
}

class UserExtensionsPanel extends React.Component {
  render() {
    const {
      t,
      ui,
      updateUI,
      isEnable,
      updateReviewSetting
    } = this.props

    return (
      <Card theme={theme}>
        <CardText theme={UserNotificationList}>
          <List selectable={false} ripple={false}>
            <ListItem key="reply-other"
                  ripple={false}
                  caption={t('label:レビュー機能')}
                  legend={!isEnable && t('label:レビュー機能OFF') || t('label:レビュー機能ON')}
                  rightActions={[
                    <SettingMenu key="review" t={t} ui={ui} updateUI={updateUI} isEnable={isEnable} updateReviewSetting={updateReviewSetting}/>
                  ]} />
          </List>
        </CardText>
      </Card>
    )
  }
}

export const RawUserExtensionsPanel = UserExtensionsPanel
export default connect(UserExtensionsPanel)



// WEBPACK FOOTER //
// ./src/web/components/user-extensions-panel.jsx